/* em-designer.js - the prototype's designer/index.html script as it was; images from the theme, the bag Shopify's through EMBag. */

(function(){
'use strict';
var reduce=matchMedia('(prefers-reduced-motion:reduce)').matches;

/* ---------- the stone library: real products, grouped by intention ---------- */
/* All leads and is the default. With eleven stones the tray opened on
   Protection and showed three of them; with twenty-nine, opening on a filter
   hides most of the range behind a tab nobody knows to press. */
var INTENTS=[
  ['*','All'],
  ['protection','Protection'],['abundance','Abundance'],['connection','Love'],
  ['calm','Calm'],['clarity','Clarity']
];
var STONES=[
  {id:'tigers-eye',   name:"Yellow Tiger's Eye",        intent:'protection', price:1.35},
  {id:'labradorite',  name:'Labradorite',        intent:'protection', price:2.10},
  {id:'malachite',    name:'Malachite',          intent:'protection', price:2.75},
  {id:'pyrite',       name:'Pyrite',             intent:'abundance',  price:1.35},
  {id:'clear-quartz', name:'Clear Quartz',       intent:'abundance',  price:1.65},
  {id:'rose-quartz',  name:'Rose Quartz',        intent:'connection', price:1.35},
  {id:'rhodochrosite',name:'Rhodochrosite',      intent:'connection', price:6.50},
  {id:'blue-agate',   name:'Blue Lace Agate',    intent:'calm',       price:2.75},
  {id:'amethyst',     name:'Amethyst',           intent:'clarity',    price:1.35},

  /* Eighteen more, and none of them invented: each is a real bead cut out of
     the product photograph of the single-stone bracelet Energy Muse sells it
     in. Their bracelets are shot flat on black, one bead deep, so the ring
     can be found and a single bead lifted off it.

     The intention is theirs too — taken from the tags on every product of
     that stone across their catalogue and resolved by weight, not guessed
     here. Black Tourmaline reads protection on 26 of their products;
     Selenite on 40. Garnet and Hematite were cut and then dropped: both are
     mirror-finish beads shot under a ring light, and the softbox reflection
     reads as a flower rather than a stone.

     Price is their own bracelet price over a 26-bead strand, to the nickel. */
  {id:'carnelian',        name:'Carnelian',                intent:'abundance',    price:1.35},
  {id:'fluorite',         name:'Fluorite',                 intent:'abundance',    price:1.35},
  {id:'iolite',           name:'Iolite',                   intent:'abundance',    price:2.10},
  {id:'jade',             name:"Canadian Jade",                     intent:'abundance',    price:2.75},
  {id:'amazonite',        name:'Amazonite',                intent:'calm',         price:1.35},
  {id:'apatite',          name:'Apatite',                  intent:'calm',         price:1.65},
  {id:'aquamarine',       name:'Aquamarine',               intent:'calm',         price:2.10},
  {id:'bloodstone',       name:'Bloodstone',               intent:'calm',         price:1.65},
  {id:'sodalite',         name:'Sodalite',                 intent:'calm',         price:1.35},
  {id:'angelite',         name:'Angelite',                 intent:'clarity',      price:2.10},
  {id:'jasper',           name:"Yellow Jasper",                   intent:'clarity',      price:1.65},
  {id:'rutilated-quartz',  name:'Rutilated Quartz',         intent:'clarity',      price:2.75},
  {id:'rhodonite',        name:'Rhodonite',                intent:'connection',   price:1.35},
  {id:'selenite',         name:'Selenite',                 intent:'protection',   price:1.65},
  {id:'shungite',         name:'Shungite',                 intent:'protection',   price:2.75},
  {id:'tourmalinated-quartz',  name:'Tourmalinated Quartz',     intent:'protection',   price:2.10}
];

/* The Energy Muse rondelle.

   A rondelle is a spacer that strings like a bead. Theirs is a short copper
   barrel with ENERGY MUSE stamped round its waist, and they want one on every
   bracelet by default. There is no product photo cut out for it yet, so it is
   drawn here instead, from their own photographs. Drawn rather than shipped as
   a PNG so it stays sharp at any device pixel ratio, and so it can be re-tuned
   without a round trip to a photo.

   Priced at 0 — included, on Clay's word, not sold as an extra bead. */
var RONDELLE_ID='em-rondelle';
function drawRondelle(px){
  var c=document.createElement('canvas'); c.width=c.height=px;
  var g=c.getContext('2d');
  var cx=px/2, cy=px/2;

  /* Geometry read off Energy Muse's own photographs. The cord runs through the
     AXIS, so on the strand this is a short copper BARREL seen from the side —
     narrow in the cord's direction, tall across it, with ENERGY MUSE cut round
     its waist. About 0.58 as wide as it is tall, a shade shorter than an 8mm
     bead, and there is no hole to see: straight on, the barrel hides its bore.

     It is ONE plain cylinder. An earlier pass turned the middle down between
     two raised flanges, and that shoulder is the whole difference between a
     spacer bead and a cotton reel. The ends are not proud of the waist — they
     simply darken as the metal turns away toward the hole.

     Sized against the bead it sits beside, not against the sprite square: a
     bead PNG fills 0.953 of its own square, and their photographs put the
     rondelle at 0.853 of a bead, so 2*rF = 0.813 of the square. */
  var rF    = px*0.407;        /* half the height, across the cord */
  var halfW = px*0.236;        /* half the length, along the cord */
  var cr    = px*0.060;        /* the corners are broken, not sharp */

  function barrel(){
    var x=cx-halfW, y=cy-rF, w=halfW*2, h=rF*2;
    g.beginPath();
    g.moveTo(x+cr,y); g.lineTo(x+w-cr,y); g.quadraticCurveTo(x+w,y,x+w,y+cr);
    g.lineTo(x+w,y+h-cr); g.quadraticCurveTo(x+w,y+h,x+w-cr,y+h);
    g.lineTo(x+cr,y+h);   g.quadraticCurveTo(x,y+h,x,y+h-cr);
    g.lineTo(x,y+cr);     g.quadraticCurveTo(x,y,x+cr,y);
    g.closePath();
  }

  /* the cylinder curves top-to-bottom as we see it, so the shading runs
     vertically: dark at both silhouette edges, one hot band a third down
     where the light wraps over the crown */
  barrel();
  var cyl=g.createLinearGradient(0,cy-rF,0,cy+rF);
  cyl.addColorStop(0,   '#2C1507');
  cyl.addColorStop(.10, '#5C3317');
  cyl.addColorStop(.26, '#A76D40');
  cyl.addColorStop(.37, '#D09E6F');
  cyl.addColorStop(.48, '#AC7446');
  cyl.addColorStop(.68, '#784625');
  cyl.addColorStop(.86, '#48270E');
  cyl.addColorStop(1,   '#291306');
  g.fillStyle=cyl; g.fill();

  g.save(); barrel(); g.clip();

  /* the ends: the metal rolls off toward the bore and goes into shadow, with a
     thin lit line right on the broken edge. This is what the photographs show
     at each side of the lettering — shadow, not a raised collar. */
  var ends=g.createLinearGradient(cx-halfW,0,cx+halfW,0);
  ends.addColorStop(0,   'rgba(30,15,5,.70)');
  ends.addColorStop(.085,'rgba(36,18,6,.34)');
  ends.addColorStop(.24, 'rgba(36,18,6,0)');
  ends.addColorStop(.76, 'rgba(36,18,6,0)');
  ends.addColorStop(.915,'rgba(36,18,6,.34)');
  ends.addColorStop(1,   'rgba(30,15,5,.66)');
  g.fillStyle=ends; g.fillRect(cx-halfW,cy-rF,halfW*2,rF*2);
  [cx-halfW+px*0.021, cx+halfW-px*0.021].forEach(function(ex){
    var lg=g.createLinearGradient(0,cy-rF,0,cy+rF);
    lg.addColorStop(0,'rgba(255,222,182,0)');
    lg.addColorStop(.34,'rgba(255,230,196,.26)');
    lg.addColorStop(.62,'rgba(255,222,182,.10)');
    lg.addColorStop(1,'rgba(255,222,182,0)');
    g.strokeStyle=lg; g.lineWidth=px*0.013;
    g.beginPath(); g.moveTo(ex,cy-rF); g.lineTo(ex,cy+rF); g.stroke();
  });

  /* sheen across the crown, and the warm bounce off the bottom */
  var sp=g.createLinearGradient(0,cy-rF*0.66,0,cy-rF*0.02);
  sp.addColorStop(0,'rgba(255,240,220,0)');
  sp.addColorStop(.48,'rgba(255,241,220,.21)');
  sp.addColorStop(1,'rgba(255,240,220,0)');
  g.fillStyle=sp; g.fillRect(cx-halfW,cy-rF,halfW*2,rF*2);
  var bo=g.createLinearGradient(0,cy+rF*0.52,0,cy+rF);
  bo.addColorStop(0,'rgba(190,116,64,0)'); bo.addColorStop(1,'rgba(190,116,64,.28)');
  g.fillStyle=bo; g.fillRect(cx-halfW,cy-rF,halfW*2,rF*2);

  /* THE STAMP, last: a cut stays dark through a highlight rather than being
     polished away by it. "ENERGY MUSE" is cut round the waist, so on the near
     face we see three or four letters at a time, lying on their side and
     squeezing together as the surface turns away above and below. Twelve
     characters round the full circumference is what the photographs show. */
  g.save();
  g.beginPath(); g.rect(cx-halfW*0.70, cy-rF, halfW*1.40, rF*2); g.clip();
  var txt='ENERGY MUSE ', step=(Math.PI*2)/txt.length;
  g.textAlign='center'; g.textBaseline='middle';
  g.font='700 '+(px*0.156).toFixed(1)+'px "Instrument Sans",-apple-system,system-ui,sans-serif';
  for(var i=0;i<txt.length;i++){
    var th=((i*step+Math.PI)%(Math.PI*2))-Math.PI;   /* only the near face */
    if(Math.abs(th)>1.30) continue;
    var ch=txt.charAt(i); if(ch===' ') continue;
    var k=Math.cos(th);                              /* foreshortening */
    g.save();
    g.translate(cx, cy-rF*0.86*Math.sin(th));
    g.rotate(-Math.PI/2);                            /* tops point along the cord */
    g.scale(k,1);                                    /* squeeze toward the edges */
    g.fillStyle='rgba(43,21,7,'+(0.40+0.46*k).toFixed(3)+')';
    g.fillText(ch,0,0);
    g.fillStyle='rgba(255,226,190,'+(0.05+0.15*k).toFixed(3)+')';
    g.fillText(ch,px*0.007,0);                       /* the lit lower wall of the cut */
    g.restore();
  }
  g.restore();

  g.restore();

  /* a hair of a dark edge so it separates from the stone either side */
  barrel(); g.strokeStyle='rgba(36,18,6,.42)'; g.lineWidth=px*0.008; g.stroke();
  return c;
}
/* ---------- the store's beads, when the section names a collection ----------
   The list above is what the page was built against and is the fallback. When a bead collection is set, every bead
   comes off its product instead - title, price, intention tag and the product's own photograph - so beads are added,
   repriced and retired in Shopify's admin and never in this file. em-intention hands back the intention's display
   name; the tray's own keys are older than that vocabulary, and 'Love' is 'connection' here. */
(function(){
  var fed = window.EM_BEADS;
  if(!fed || !fed.length) return;
  var KEY={'Protection':'protection','Abundance':'abundance','Love':'connection','Calm':'calm','Clarity':'clarity'};
  var out=[];
  for(var i=0;i<fed.length;i++){
    var b=fed[i]; if(!b || !b.id) continue;
    out.push({id:String(b.id), name:b.name||String(b.id), intent:KEY[b.cat]||'*', price:+b.price||0, src:b.src||'', vid:b.vid||0});
  }
  if(out.length) STONES=out;
})();

STONES.push({id:RONDELLE_ID, name:'Energy Muse rondelle', intent:'*', price:0,
             fixed:true, tangent:true, sizeK:0.74, img:drawRondelle(256)});

/* Repaint when a stone finishes decoding. Without this, a bead tapped before
   its PNG arrived was skipped by the paint pass and — because the canvas only
   repaints on change — never drawn again: on a cold phone cache it looked like
   only the one cached stone would add. */
/* One place decides where a bead's picture comes from: the product's own photograph when the bead came from the
   store, otherwise the file this theme ships. The tray tile, the bead on the strand and the thumbnail that goes to
   the bag all ask here, so they cannot disagree - the first version of this fixed only the strand and left the tray
   asking for a theme file that a store-fed bead has never had. */
function beadImg(s){ return (s && s.src) || (window.EM_ASSET_BASE+'bead-'+(s?s.id:'')+'.png'); }

STONES.forEach(function(s){
  if(s.fixed)return;                 /* the rondelle is drawn, not fetched */
  s.img=new Image();
  s.img.onload=function(){invalidate();};
  /* the product's own photograph when the bead came from the store, otherwise the one this theme ships */
  s.img.src=beadImg(s);
});
/* Sprites come two ways now: the stones are <img> and load asynchronously, the
   rondelle is a <canvas> drawn at startup. An Image reports readiness through
   .complete/.naturalWidth, a canvas has neither and is ready the moment it
   exists — so guarding on the Image properties alone silently skipped the
   rondelle on every frame, and left the paint loop marking itself dirty
   forever waiting for a load that had already happened. */
function ready(img){ return !!img && (img.tagName==='CANVAS' ? img.width>0 : (img.complete && img.naturalWidth>0)); }
function byId(id){for(var i=0;i<STONES.length;i++)if(STONES[i].id===id)return STONES[i];return null;}

/* recipes: a focal stone plus grounding companions, per intention */
var RECIPES={
  protection:['tigers-eye','tigers-eye','labradorite','tigers-eye','malachite','tigers-eye','labradorite','tigers-eye'],
  abundance:['pyrite','clear-quartz','pyrite','himalayan','pyrite','clear-quartz','pyrite','clear-quartz'],
  connection:['rose-quartz','rose-quartz','rhodochrosite','rose-quartz','rose-quartz','rhodochrosite','rose-quartz','rose-quartz'],
  calm:['blue-agate','blue-agate','blue-opal','blue-agate','clear-quartz','blue-agate','blue-opal','blue-agate'],
  clarity:['amethyst','clear-quartz','amethyst','clear-quartz','amethyst','clear-quartz','amethyst','clear-quartz']
};

/* Sept 29: the recipes above name stones by id, and the tray's ids are now whatever Sara's
   bead products are called in Shopify. Any name she does not carry silently laid down a bead
   that does not exist - Sara found a calm strand asking for blue-agate and blue-opal, neither
   of them in her collection, so 25 slots came back holding 3 stones and $4.95. Recipes are
   repaired against whatever the tray actually holds: a missing stone is replaced by another
   of the same intention, rotating so the strand still alternates rather than going solid. A
   recipe with nothing left falls back to that intention's first few stones. Nothing here
   depends on a particular bead existing, so the next time the collection changes it holds. */
(function(){
  var have = {}, byIntent = {};
  STONES.forEach(function (s) {
    if (!s || !s.id) return;
    have[s.id] = 1;
    if (s.intent && s.intent !== '*') (byIntent[s.intent] = byIntent[s.intent] || []).push(s.id);
  });
  Object.keys(RECIPES).forEach(function (k) {
    var pool = byIntent[k] || [], n = 0;
    var fixed = RECIPES[k].map(function (id) {
      if (have[id]) return id;
      return pool.length ? pool[(n++) % pool.length] : null;
    }).filter(Boolean);
    if (!fixed.length) fixed = pool.slice(0, 4);
    RECIPES[k] = fixed;
  });
})();

/* ---------- state ---------- */
var strand=[];              /* array of stone ids, in order around the circle */
var tab='*';
var wristIn=7.5, unit='in';
var BEAD_MM=8;              /* 8mm beads — the house standard */
var RONDELLE_MM=3;          /* the Energy Muse rondelle is thinner than a bead */
/* stones only — the rondelle takes a slot but not a bead's worth of cord */
function stoneCount(){return Math.max(6,Math.round((wristIn*25.4-RONDELLE_MM)/BEAD_MM));}
function capacity(){return stoneCount()+1;}

/* ---------- canvas ---------- */
var cv=document.getElementById('strand'),ctx=cv.getContext('2d');
var stage=document.getElementById('stage');
var W=0,H=0,dpr=1,mob=false;
/* Phones were repainting 21 beads with a blurred shadow every frame, which
   is what made this feel laggy. Two fixes: a pre-baked contact shadow
   instead of ctx.shadowBlur, and a dirty flag so we only paint when
   something actually moves. */
var SHADOW=(function(){
  var g=document.createElement('canvas');g.width=g.height=96;
  var c=g.getContext('2d');
  var rg=c.createRadialGradient(48,48,1,48,48,48);
  rg.addColorStop(0,'rgba(61,41,23,.42)');
  rg.addColorStop(.55,'rgba(61,41,23,.19)');
  rg.addColorStop(1,'rgba(61,41,23,0)');
  c.fillStyle=rg;c.fillRect(0,0,96,96);
  return g;
})();
var dirty=true,paints=0;
function invalidate(){dirty=true;}
function resize(){
  W=stage.clientWidth;H=stage.clientHeight;
  mob=W<=900||matchMedia('(pointer:coarse)').matches;
  /* phones ship 3x screens; 1.5x is indistinguishable here and ~4x cheaper */
  dpr=Math.min(devicePixelRatio||1,mob?1.5:2);
  cv.width=Math.round(W*dpr);cv.height=Math.round(H*dpr);
  cv.style.width=W+'px';cv.style.height=H+'px';
  ctx.setTransform(dpr,0,0,dpr,0,0);
  invalidate();
}
new ResizeObserver(resize).observe(stage);resize();

/* per-bead animation state, keyed by slot index */
var anim=[];                 /* {born:ms, from:angle} */
var pulse=-1;                /* ms timestamp of the last add, drives the copper wave */
var spin=0;                  /* slow idle rotation */
var dragIdx=-1,dragAng=0,hoverIdx=-1;

/* Each bead glows its own colour — read off the bead's own pixels, weighted
   toward the saturated ones so the stone's character wins over its matrix. */
function stoneColor(img){
  var n=24,c=document.createElement('canvas');c.width=c.height=n;
  var g=c.getContext('2d');g.drawImage(img,0,0,n,n);
  var d;try{d=g.getImageData(0,0,n,n).data;}catch(e){return [200,140,88];}
  var r=0,gg=0,b=0,w=0;
  for(var i=0;i<d.length;i+=4){
    if(d[i+3]<160)continue;
    var mx=Math.max(d[i],d[i+1],d[i+2]),mn=Math.min(d[i],d[i+1],d[i+2]);
    var sat=(mx-mn)/(mx||1), lum=mx/255;
    var wt=0.12+sat*1.9;
    wt*=(lum>0.16&&lum<0.97)?1:0.25;
    r+=d[i]*wt;gg+=d[i+1]*wt;b+=d[i+2]*wt;w+=wt;
  }
  if(!w)return [200,140,88];
  r/=w;gg/=w;b/=w;
  var mx2=Math.max(r,gg,b)||1,k=Math.min(255/mx2,1.9);
  r=Math.min(255,r*k*0.98);gg=Math.min(255,gg*k*0.98);b=Math.min(255,b*k*0.98);
  var avg=(r+gg+b)/3;
  function cl(v){return v<0?0:v>255?255:v;}
  /* saturate toward the stone's character, but never past a legal channel */
  r=cl(avg+(r-avg)*1.35);gg=cl(avg+(gg-avg)*1.35);b=cl(avg+(b-avg)*1.35);
  /* keep a floor so a dark stone still throws light rather than a shadow */
  var mxf=Math.max(r,gg,b);
  if(mxf<150){var lift=150/(mxf||1);r=cl(r*lift);gg=cl(gg*lift);b=cl(b*lift);}
  return [Math.round(r),Math.round(gg),Math.round(b)];
}
function makeGlow(col,peak){
  var g=document.createElement('canvas');g.width=g.height=128;
  var c=g.getContext('2d');
  var rgb=col[0]+','+col[1]+','+col[2];
  var rg=c.createRadialGradient(64,64,2,64,64,64);
  rg.addColorStop(0,'rgba('+rgb+','+(peak||.62)+')');
  rg.addColorStop(.42,'rgba('+rgb+',.28)');
  rg.addColorStop(.72,'rgba('+rgb+',.09)');
  rg.addColorStop(1,'rgba('+rgb+',0)');
  c.fillStyle=rg;c.fillRect(0,0,128,128);
  return g;
}
function glowOf(s){
  if(!s.glow&&ready(s.img)){
    s.col=stoneColor(s.img);s.glow=makeGlow(s.col);
  }
  return s.glow;
}
/* the pool the whole strand rests in: an average of what's on it */
var POOL=null,poolKey='';
function poolGlow(){
  var key=strand.join(',');
  if(key===poolKey&&POOL)return POOL;
  var r=0,g=0,b=0,n=0;
  strand.forEach(function(id){
    var s=byId(id);if(!s||!ready(s.img))return;
    if(!s.col)s.col=stoneColor(s.img);
    r+=s.col[0];g+=s.col[1];b+=s.col[2];n++;
  });
  if(!n)return null;
  POOL=makeGlow([Math.round(r/n),Math.round(g/n),Math.round(b/n)],.34);
  poolKey=key;return POOL;
}

function radius(){return Math.min(W,H)*0.30;}
function beadPx(){
  /* beads scale with how full the strand is, so a big wrist reads bigger */
  var n=Math.max(strand.length,8);
  /* The stones used to give back a sixth of their arc so a copper round could
     sit in every gap. There are no rounds now, and a strung elastic bracelet
     has no gaps — the stones bear on each other. A hair under the full share
     so neighbours read as separate spheres rather than merging into a tube. */
  return Math.min(radius()*2*Math.PI/n*0.97, radius()*0.42);
}
function angleOf(i,n){return -Math.PI/2+(i/n)*Math.PI*2;}

function busy(ts){
  if(dragIdx>=0||pulse>0)return true;
  for(var i=0;i<anim.length;i++)if(anim[i])return true;
  return false;
}
function draw(ts){
  /* idle spin is a desktop luxury; on a phone it would repaint forever */
  var moving=busy(ts)||(!mob&&!reduce);
  if(!moving&&!dirty){requestAnimationFrame(draw);return;}
  dirty=false;paints++;
  ctx.clearRect(0,0,W,H);
  var cx=W/2, cy=H/2, R=radius(), n=strand.length;
  if(!reduce&&!mob)spin+=0.0009;

  /* ambient pool of light the strand rests in — tinted by the strand itself */
  var pg=n?poolGlow():null;
  if(pg){
    var pool=R*3.1;
    ctx.save();ctx.globalAlpha=.55;
    ctx.drawImage(pg,cx-pool/2,cy-pool/2,pool,pool);
    ctx.restore();
  }

  /* Empty, this is the etched true-scale ring — the bracelet at actual size.
     Strung, it becomes the cord itself: the stones used to hang in a ring with
     nothing joining them, which is what made this read as a diagram rather
     than a bracelet. */
  var bpc=beadPx();
  ctx.save();
  if(!n){
    ctx.strokeStyle='rgba(169,104,62,.22)';ctx.lineWidth=1;
    ctx.beginPath();ctx.arc(cx,cy,R,0,6.283);ctx.stroke();
  }else{
    var cw=Math.max(1.5,bpc*0.075);   /* a thread, not a rope */
    ctx.lineCap='round';
    ctx.strokeStyle='rgba(74,58,42,.55)';ctx.lineWidth=cw;
    ctx.beginPath();ctx.arc(cx,cy,R,0,6.283);ctx.stroke();
    /* a thread catches the light along its top edge */
    ctx.strokeStyle='rgba(226,205,180,.42)';ctx.lineWidth=cw*0.34;
    ctx.beginPath();ctx.arc(cx,cy-cw*0.22,R,Math.PI*1.08,Math.PI*1.92);ctx.stroke();
  }
  ctx.restore();

  /* the copper pulse travelling the ring after each addition */
  if(pulse>0){
    var age=(ts-pulse)/900;
    if(age<1){
      var head=-Math.PI/2+age*Math.PI*2;
      var g=ctx.createLinearGradient(cx+Math.cos(head-.6)*R,cy+Math.sin(head-.6)*R,cx+Math.cos(head)*R,cy+Math.sin(head)*R);
      g.addColorStop(0,'rgba(224,168,120,0)');g.addColorStop(1,'rgba(224,168,120,'+(0.85*(1-age)).toFixed(2)+')');
      ctx.save();ctx.strokeStyle=g;ctx.lineWidth=2.4;ctx.lineCap='round';
      ctx.beginPath();ctx.arc(cx,cy,R,head-.6,head);ctx.stroke();ctx.restore();
    }else pulse=-1;
  }

  if(!n){
    ctx.save();
    ctx.fillStyle='rgba(141,135,120,.9)';
    ctx.font='300 17px Fraunces, Georgia, serif';ctx.textAlign='center';
    ctx.fillText('Choose a stone to begin.',cx,cy+5);
    ctx.restore();
  }

  var bp=beadPx();
  for(var i=0;i<n;i++){
    var s=byId(strand[i]);
    /* not decoded yet — stay dirty so this stone gets drawn the moment it is */
    if(!s||!ready(s.img)){dirty=true;continue;}
    var target=angleOf(i,n)+spin;
    var a=target,sc=1,extra=0;
    if(i===dragIdx){a=dragAng;sc=1.14;extra=6;}
    else{
      var st=anim[i];
      if(st){
        var k=Math.min(1,(ts-st.born)/520);
        if(k<1){
          var e=1-Math.pow(1-k,3);
          /* it falls in from outside the ring and the neighbours part to receive it */
          extra=(1-e)*R*0.85;
          sc=0.55+0.45*e+Math.sin(e*Math.PI)*0.12;
        }else anim[i]=null;
      }
    }
    var rr=R+extra;
    var x=cx+Math.cos(a)*rr, y=cy+Math.sin(a)*rr;
    var d=bp*sc;
    /* halo first, so the stone sits inside its own light */
    var lit=(i===hoverIdx&&dragIdx<0)||i===dragIdx;
    var gd=d*(lit?2.5:1.95);
    var gl=glowOf(s);
    if(gl){
      ctx.save();
      ctx.globalAlpha=lit?.85:.5;
      ctx.drawImage(gl,x-gd/2,y-gd/2,gd,gd);
      ctx.restore();
    }
    /* A rondelle is a spacer, not a bead — on a real strand it sits smaller
       than the stones it separates. Drawn at the full bead diameter it read
       as another bead that happened to be copper. */
    var dk=d*(s.sizeK||1);
    /* baked contact shadow — no per-frame blur filter */
    var sh=dk*1.34;
    ctx.save();
    ctx.globalAlpha=lit?.85:.7;
    ctx.drawImage(SHADOW,x-sh/2,y-sh/2+d*0.14,sh,sh);
    ctx.restore();
    if(s.tangent){
      /* the barrel is drawn lying along +x; on the strand it has to lie along
         the tangent, or it reads as a barrel at the top of the ring and a
         squashed brick at the sides */
      ctx.save(); ctx.translate(x,y); ctx.rotate(a+Math.PI/2);
      ctx.drawImage(s.img,-dk/2,-dk/2,dk,dk); ctx.restore();
    }else ctx.drawImage(s.img,x-dk/2,y-dk/2,dk,dk);
  }
  requestAnimationFrame(draw);
}
requestAnimationFrame(draw);

/* ---------- pointer: drag to rearrange, drag out to remove ---------- */
function pos(e){var r=cv.getBoundingClientRect();return [e.clientX-r.left,e.clientY-r.top];}
/* Fixed pieces are not pickable. The rondelle is included on every bracelet
   and is not the wearer's to take off, so it must never answer a hit test —
   hover, pointerdown and drag-out all come through here, so refusing it once
   here means it cannot be grabbed, cannot be reordered, cannot be flung off
   the ring, and never shows the grab cursor that would invite the attempt. */
function nearest(x,y){
  var cx=W/2,cy=H/2,R=radius(),n=strand.length,bp=beadPx(),best=-1,bd=bp*0.75;
  for(var i=0;i<n;i++){
    var st=byId(strand[i]); if(st&&st.fixed) continue;
    var a=angleOf(i,n)+spin;
    var dx=x-(cx+Math.cos(a)*R), dy=y-(cy+Math.sin(a)*R);
    var d=Math.sqrt(dx*dx+dy*dy);
    if(d<bd){bd=d;best=i;}
  }
  return best;
}
cv.addEventListener('pointermove',function(e){
  var p=pos(e,0),x=p[0],y=p[1];
  if(dragIdx>=0){
    dragAng=Math.atan2(y-H/2,x-W/2);
    var n=strand.length;
    var slot=Math.round(((dragAng-spin+Math.PI/2)/(Math.PI*2))*n);
    slot=((slot%n)+n)%n;
    if(slot!==dragIdx){
      var moved=strand.splice(dragIdx,1)[0];
      strand.splice(slot,0,moved);
      anim.splice(dragIdx,1);anim.splice(slot,0,null);
      dragIdx=slot;
    }
    invalidate();
  }else{
    var prev=hoverIdx;
    hoverIdx=nearest(x,y);
    if(prev!==hoverIdx){cv.style.cursor=hoverIdx>=0?'grab':'default';invalidate();}
  }
});
cv.addEventListener('pointerdown',function(e){
  var p=pos(e),i=nearest(p[0],p[1]);
  if(i>=0){dragIdx=i;dragAng=Math.atan2(p[1]-H/2,p[0]-W/2);cv.classList.add('drag');cv.setPointerCapture(e.pointerId);invalidate();}
});
function endDrag(e){
  if(dragIdx<0)return;
  var p=pos(e),d=Math.sqrt(Math.pow(p[0]-W/2,2)+Math.pow(p[1]-H/2,2));
  if(d>radius()*1.75){        /* flung away from the ring = take it off */
    var s=byId(strand[dragIdx]);
    strand.splice(dragIdx,1);anim.splice(dragIdx,1);
    if(s)toast(s.name+' removed');
    sync();
  }
  dragIdx=-1;cv.classList.remove('drag');invalidate();
}
cv.addEventListener('pointerup',endDrag);
cv.addEventListener('pointercancel',endDrag);

/* ---------- tray ---------- */
var tabsEl=document.getElementById('tabs'),beadsEl=document.getElementById('beads');
INTENTS.forEach(function(pair){
  var b=document.createElement('button');
  b.className='tab'+(pair[0]===tab?' on':'');b.textContent=pair[1];
  b.setAttribute('role','tab');b.setAttribute('aria-selected',pair[0]===tab?'true':'false');
  b.addEventListener('click',function(){
    tab=pair[0];
    [].forEach.call(tabsEl.children,function(c,i){
      var on=INTENTS[i][0]===tab;c.classList.toggle('on',on);c.setAttribute('aria-selected',on?'true':'false');
    });
    renderTray();
  });
  tabsEl.appendChild(b);
});
function renderTray(){
  beadsEl.innerHTML='';
  STONES.filter(function(s){
    if(s.fixed)return false;              /* the rondelle is fitted, not chosen */
    return tab==='*' || s.intent===tab;
  }).forEach(function(s){
    var b=document.createElement('button');b.className='bead';
    b.innerHTML='<img src="'+beadImg(s)+'" alt="'+s.name+' bead" width="52" height="52">'+
      '<span class="bn">'+s.name+'</span><span class="bp">$'+s.price.toFixed(2)+'</span>';
    b.addEventListener('click',function(){addBead(s.id);});
    beadsEl.appendChild(b);
  });
}
renderTray();

function addBead(id){
  if(strand.length>=capacity()){toast('That fills a '+fmtWrist()+' wrist');return;}
  strand.push(id);
  anim[strand.length-1]={born:performance.now()};
  pulse=performance.now();
  invalidate();sync();
}

var composeN=0;
document.getElementById('compose').addEventListener('click',function(){
  var r=RECIPES[tab]||[];
  if(tab==='*'){
    /* under All there is no single intention to compose for, so take the lead
       stone of each one in turn — a strand that shows the whole range */
    r=[];
    for(var q=0;q<INTENTS.length;q++){
      var rec=RECIPES[INTENTS[q][0]];
      if(rec&&rec.length)r.push(rec[0],rec[2]||rec[0]);
    }
  }
  if(!r.length)return;
  /* Sept 11, Sara (builder Loom, 0:48): "if I start over, it's still giving me
     the same one... suggest a different design". Each press turns the recipe:
     the focal stone stays, the companions rotate and, every other press, run
     the other way round the wrist. */
  composeN++;
  var rot=composeN%r.length, seq=r.slice(rot).concat(r.slice(0,rot)); if(composeN%2===0)seq.reverse();
  /* the pattern repeats around the whole wrist, so the strand is a real one */
  strand=[];for(var i=0;i<stoneCount();i++)strand.push(seq[i%seq.length]);
  ensureRondelle();
  anim=strand.map(function(_,i){return {born:performance.now()+i*32};});
  pulse=performance.now();
  var label='';INTENTS.forEach(function(p){if(p[0]===tab)label=p[1];});
  toast(tab==='*' ? 'A strand across every intention — adjust it however you like'
                  : 'A '+label.toLowerCase()+' strand — adjust it however you like');
  sync();
});
/* One rondelle, always. It is a normal strand entry so the arithmetic, the
   spacing and the reordering of its neighbours all treat it as a bead, but it
   is marked fixed and so cannot be picked up — see nearest(). This guarantees
   there is exactly one and puts it at the clasp point when there is none. */
function ensureRondelle(){
  var at=strand.indexOf(RONDELLE_ID);
  if(at<0){ strand.splice(Math.floor(strand.length/2),0,RONDELLE_ID); }
  else {
    for(var i=strand.length-1;i>=0;i--)
      if(i!==at && strand[i]===RONDELLE_ID) strand.splice(i,1);
  }
  if(anim.length!==strand.length)
    anim=strand.map(function(_,i){return {born:performance.now()+i*32};});
}

document.getElementById('clear').addEventListener('click',function(){
  strand=[];anim=[];ensureRondelle();invalidate();sync();
});

/* ---------- sizing ----------
   Standard sizes only. The slider offered every quarter inch from 5 to 9 —
   thirty-three sizes for a product that comes in three, and every one of them
   reading as orderable. Each size carries its bead count, because that is the
   question people are actually asking when they choose one. */
/* Their three sizes, and their bead counts. 8½ was not one of them.
   Energy Muse: 6¾ is 21 beads plus the rondelle, 7½ is 23 plus, 8 is 25
   plus — which is exactly round((circumference - 3mm) / 8mm), so the
   rondelle is about 3mm and the count is derived rather than tabulated. */
var SIZES=[{in:6.75,label:'6¾″'},{in:7.5,label:'7½″'},{in:8,label:'8″'}];
function beadsFor(inches){return Math.round((inches*25.4-RONDELLE_MM)/BEAD_MM);}
function nearestSize(inches){
  var best=SIZES[1], d=Infinity;
  SIZES.forEach(function(z){var k=Math.abs(z.in-inches);if(k<d){d=k;best=z;}});
  return best;
}
var sizesEl=document.getElementById('sizes');
/* Sept 25 (Sara): the packaging upgrade is part of what the bracelet costs, so it belongs in the running total
   and in the price the cart is charged - not bolted on afterwards where the two would disagree. */
function packChoice(){ var r=document.querySelector('input[name=empack]:checked'); return r?r.value:'standard'; }
function packCost(){ return (window.EM_PACK && packChoice()==='upsell') ? Number(window.EM_PACK.price)||0 : 0; }
function packLabel(){ if(!window.EM_PACK) return ''; return packChoice()==='upsell'?window.EM_PACK.upsell:window.EM_PACK.standard; }
function fmtWrist(){return unit==='in'? nearestSize(wristIn).label : (wristIn*2.54).toFixed(1)+' cm';}
function buildSizes(){
  sizesEl.innerHTML='';
  SIZES.forEach(function(z){
    var b=document.createElement('button');
    b.type='button';b.setAttribute('role','radio');
    var label=unit==='in'?z.label:(z.in*2.54).toFixed(1)+' cm';
    var n=beadsFor(z.in);
    b.innerHTML='<span class="sz">'+label+'</span><span class="bd">'+n+' beads</span>';
    b.setAttribute('aria-label',label+', '+n+' beads');
    b.addEventListener('click',function(){wristIn=z.in;syncWrist();});
    sizesEl.appendChild(b);
  });
}
function syncWrist(){
  var z=nearestSize(wristIn);
  wristIn=z.in;
  document.getElementById('wval').textContent=unit==='in'?z.label:(z.in*2.54).toFixed(1)+' cm';
  document.getElementById('wsub').textContent=beadsFor(z.in)+' beads';
  [].forEach.call(sizesEl.children,function(b,k){
    b.setAttribute('aria-checked',SIZES[k].in===z.in?'true':'false');
  });
  if(strand.length>capacity()){strand=strand.slice(0,capacity());anim=anim.slice(0,capacity());}
  ensureRondelle();   /* a trim can cut it off the end */
  sync();
}
buildSizes();
document.getElementById('uin').addEventListener('click',function(){setUnit('in');});
document.getElementById('ucm').addEventListener('click',function(){setUnit('cm');});
function setUnit(u){
  unit=u;
  document.getElementById('uin').classList.toggle('on',u==='in');
  document.getElementById('ucm').classList.toggle('on',u==='cm');
  document.getElementById('uin').setAttribute('aria-checked',u==='in');
  document.getElementById('ucm').setAttribute('aria-checked',u==='cm');
  buildSizes();syncWrist();
}

/* ---------- readouts ---------- */
var sigEl=document.getElementById('sig');
function sync(){
  invalidate();
  var total=0,mix={};
  strand.forEach(function(id){
    var s=byId(id);if(!s)return;
    total+=s.price;mix[s.intent]=(mix[s.intent]||0)+1;
  });
  total += packCost();                       /* the chosen bag is part of the price */
  /* Sept 28: show what the till will take, not what the beads add up to. Shopify can only charge a
     variant's own price, so the piece is rung up against the cheapest rung at or above the design.
     Showing the raw bead total meant a short strand read $4.05 and charged $28 - the fourth time on
     this project the page and the bag disagreed, and the largest. window.emTier is the cart's own
     function, so they cannot drift. No ladder wired yet? Fall back to the design total, as before. */
  var rung = window.emTier ? window.emTier(total) : null;
  var making = window.emMakingCharge ? window.emMakingCharge() : 0;
  /* The packaging upsell is a PRICE in the section settings, not a product, so once the beads are
     itemised there is no line to charge it on - the page would show it and the till would not take it.
     That is the divergence this file keeps being bitten by, so in itemised mode it comes back out of
     what we show. Charging for the upgraded bag alongside itemised beads needs a real product to put
     it on; until there is one, the bag is shown as included rather than quietly added and never taken.
     Moot today - bag_price is unset, so packCost() is 0 - but it would not stay moot. */
  var itemising = ((window.EM_BUILDER_TIERS || []).length <= 1);
  var charged = (rung && !rung.over) ? rung.price
              : (itemising ? total - packCost() + making : total + making);
  var tstr=strand.length?'$'+charged.toFixed(2):'⁠—';
  document.getElementById('tval').textContent=tstr;
  document.getElementById('mtotal').textContent=tstr;
  /* the label says stones, so count stones - the rondelle is fitted, not chosen */
  var stones=strand.filter(function(id){return id!==RONDELLE_ID;}).length;
  /* Oct 5 (Sara, via Timmi, order #257595): "someone selected a 6 3/4 bracelet but only chose 19/21
     of the beads. Therefore, her bracelet will be too small. Can you make it a requirement to choose
     the amount designated for each size?" addBead has always refused to go OVER a size - "That fills
     a 6 3/4 wrist" - and nothing ever checked the other end: Add to Bag unlocked at four beads, so a
     part-built strand ordered as happily as a finished one. The count was on screen the whole time,
     reading 19 / 21, which is exactly why a counter on its own is not enough. */
  var short=stoneCount()-stones;
  var tsub=document.getElementById('tsub');
  if(tsub){
    if(!strand.length) tsub.textContent='';
    else if(rung&&rung.over) tsub.textContent='above what we can charge online';
    else if(short>0){var wl=fmtWrist();tsub.textContent=short+' more '+(short===1?'stone':'stones')+
      ' to finish '+(/^8/.test(wl)?'an ':'a ')+wl;}
    else if(rung&&total<rung.floor-0.005) tsub.textContent='minimum for a handmade piece';
    else tsub.textContent='';
  }
  document.getElementById('cval').textContent=stones+' / '+stoneCount();
  document.getElementById('addbag').disabled=short>0||!!(rung&&rung.over);
  document.getElementById('note').style.opacity=(strand.length&&strand.length<3)?1:0;

  sigEl.innerHTML='';
  INTENTS.forEach(function(p){
    var c=mix[p[0]]||0;if(!c)return;
    var row=document.createElement('div');row.className='sigrow';
    row.innerHTML='<span class="siglab">'+p[1]+'</span><span class="sigbar"><i style="width:'+
      Math.round(c/strand.length*100)+'%"></i></span><span>'+c+'</span>';
    sigEl.appendChild(row);
  });
}
syncWrist();sync();

/* ---------- toast + bag ---------- */
var toastEl=document.getElementById('toast'),toastT;
function toast(msg){
  toastEl.textContent=msg;toastEl.classList.add('on');
  clearTimeout(toastT);toastT=setTimeout(function(){toastEl.classList.remove('on');},2400);
}
document.getElementById('addbag').addEventListener('click',function(){
  var total=0,mix={};
  strand.forEach(function(id){var s=byId(id);if(s){total+=s.price;mix[s.intent]=(mix[s.intent]||0)+1;}});
  /* the bag is part of the price. This total is worked out separately from the one on screen, so leaving it out
     here showed the customer $51.40 and charged the cart against $43.40 - the display and the till disagreeing,
     which is the same fault the flat bracelet price had. */
  total += packCost();
  var top='',topN=0;
  Object.keys(mix).forEach(function(k){if(mix[k]>topN){topN=mix[k];top=k;}});
  var label='';INTENTS.forEach(function(p){if(p[0]===top)label=p[1];});
  var nm=(document.getElementById('bname').value||'').trim();
  var name=nm||('Custom '+label+' Bracelet');
  var lead=byId(strand[0]);
  /* compact, stable signature so two identical designs stack in the bag */
  var sig=0,src=strand.join(',')+'|'+wristIn;
  for(var si=0;si<src.length;si++){sig=(sig*31+src.charCodeAt(si))>>>0;}
  if(window.EMBag){
    /* what the person stringing it actually needs: a tally to pick the beads, the order to thread them in, and a
       link that rebuilds the piece if they want to see it. designURL() already exists for the share button - it
       just was never called at this point, which is why the order carried a link to an empty builder. */
    var seq=strand.map(function(id){var s=byId(id);return s?s.name:id;});
    var tally={}; seq.forEach(function(n){tally[n]=(tally[n]||0)+1;});
    var pick=Object.keys(tally).sort().map(function(n){return tally[n]+' × '+n;}).join(', ');
    /* the same machine-readable line as the box - product handles and counts, hidden from the cart by
       the underscore. The beads are not inventory-tracked today, so nothing can act on it yet; it costs
       nothing to carry and means the day tracking goes on, the orders already say what left. Every id
       here is a real product handle in build-your-own-bracelet-beads - the rondelle is not, it is a
       fitted part nobody sells on its own, so it stays out of a line whose whole promise is that each
       entry can be looked up. It is still named in "Beads to pick", which is what the packer reads. */
    var htally={}; strand.forEach(function(id){var s=byId(id); if(s&&s.fixed)return; htally[id]=(htally[id]||0)+1;});
    var handles=Object.keys(htally).sort().map(function(h){return h+':'+htally[h];}).join(',');
    /* variant ids, the line the automation reads - see the note in em-box.js. The rondelle drops out here
       too: it has no product and therefore no variant. */
    var vtally={}; strand.forEach(function(id){var b=byId(id); if(!b||b.fixed||!b.vid)return; vtally[b.vid]=(vtally[b.vid]||0)+1;});
    var vids=Object.keys(vtally).sort().map(function(v){return v+':'+vtally[v];}).join(',');
    /* the same tally as _beads_v, as cart lines: what Shopify will actually subtract. Only sent;
       em-cart.js ignores it until the product's price ladder is retired. */
    var lines=Object.keys(vtally).sort().map(function(v){return {id:Number(v), quantity:vtally[v]};});
    window.EMBag.add({
      lines:lines,
      id:'atelier-'+sig.toString(36),
      name:name+' · '+fmtWrist(),
      price:Math.round(total*100)/100,
      img:lead?beadImg(lead):'',
      link:location.pathname,
      props:{
        'Size':        fmtWrist()+' — '+seq.length+' stones',
        'Packaging':   packLabel(),
        'Beads to pick': pick,
        'String in this order': seq.join(' · '),
        '_beads':      handles,
        '_beads_v':    vids,
        'Link':        designURL()
      }
    });
  }else toast('Bag is still loading — try again');
});

/* ---------- a design is a link ----------
   The strand is encoded as one-character stone codes so a whole bracelet
   fits in a short URL you can text: /designer/?s=aabcaab&w=6.5&n=Morning.
   Send it and it opens as *your* bracelet, not an empty stage. */
var CODE={},FROMCODE={};
/* String.fromCharCode(97+i) ran off the end of the alphabet at the 27th stone
   and started emitting '{', '|', '}' — characters a URL will not carry
   intact. There are 29 stones now. This is the same 64-character URL-safe
   alphabet the box builder uses, and it is indexed in id order so a link
   shared today still opens tomorrow if the tray is reordered. */
var ALPHA='abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789-_';
STONES.slice().sort(function(a,b){return a.id<b.id?-1:a.id>b.id?1:0;})
  .forEach(function(s,i){
    if(i>=ALPHA.length)return;
    var ch=ALPHA.charAt(i);CODE[s.id]=ch;FROMCODE[ch]=s.id;
  });

function designURL(){
  var q='?s='+strand.map(function(id){return CODE[id]||'';}).join('')+'&w='+wristIn;
  var nm=(document.getElementById('bname').value||'').trim();
  if(nm)q+='&n='+encodeURIComponent(nm.slice(0,34));
  return location.origin+location.pathname+q;
}
function restore(){
  var q=new URLSearchParams(location.search);
  var s=q.get('s'),w=parseFloat(q.get('w')),nm=q.get('n');
  /* links made before we settled on three sizes carry any quarter inch, so
     they snap to the nearest size we make rather than opening at one we do not */
  if(w>=5&&w<=9)wristIn=nearestSize(w).in;
  if(nm)document.getElementById('bname').value=nm;
  if(s){
    var got=[];
    for(var i=0;i<s.length;i++){var id=FROMCODE[s[i]];if(id)got.push(id);}
    if(got.length){
      strand=got.slice(0,capacity());
      anim=strand.map(function(_,k){return {born:performance.now()+k*26};});
      pulse=performance.now();
    }
  }
  /* every bracelet carries the rondelle, including one opened from a link made
     before it existed, and an empty board on a cold visit */
  ensureRondelle();
  syncWrist();sync();
  if(s&&strand.length)toast('Opened a shared design — make it yours');
}

/* the bag changes the price, so redraw the totals when it is switched */
document.addEventListener('change',function(e){
  if(e.target && e.target.name==='empack' && typeof sync==='function') sync();
});
document.getElementById('share').addEventListener('click',function(){
  if(!strand.length){toast('Add a stone or two first');return;}
  var url=designURL();
  /* keep the address bar in step, so a plain copy-paste works too */
  try{history.replaceState(null,'',url);}catch(e){}
  function fallback(){
    var t=document.createElement('textarea');t.value=url;t.style.position='fixed';t.style.opacity=0;
    document.body.appendChild(t);t.select();
    try{document.execCommand('copy');toast('Link copied — send your bracelet');}
    catch(e){toast('Copy this page’s address to share');}
    document.body.removeChild(t);
  }
  if(navigator.clipboard&&navigator.clipboard.writeText){
    navigator.clipboard.writeText(url).then(function(){toast('Link copied — send your bracelet');},fallback);
  }else fallback();
});

restore();

/* keyboard: escape cancels a drag */
addEventListener('keydown',function(e){if(e.key==='Escape'&&dragIdx>=0){dragIdx=-1;cv.classList.remove('drag');}});

/* verification hook */
window.__atelier={add:addBead,rondelle:drawRondelle,strand:function(){return strand.slice();},url:function(){return designURL();},paints:function(){return paints;},tick:function(){draw(performance.now());},compose:function(){document.getElementById('compose').click();},
  state:function(){return {strand:strand.slice(),cap:capacity(),wristIn:wristIn,unit:unit};}};
})();
